import { defaultParamList } from '@helpers/constant';
import React, { Fragment, useEffect, useState } from 'react';
import useAction from '../hooks/useAction';
import Filter from './filter';
import Table from './table';

export default function (props: any) {
    const { data, getData, metaData, isLoader, deleteData } = useAction();
    const [params, setParams]: any = useState(defaultParamList);
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async (newParams?: any) => {
        const param = {
            ...params,
            ...newParams
        };
        Object.keys(param).forEach(key => param[key] === "" && delete param[key]);
        await setParams(param);
        getData(param);

    };

    const onSearch = (search: string) => {
        const param = Object.assign({ page: 1, search });
        fetchData(param)
    }

    const onChangeStatus = (status: string) => {
        const param = Object.assign({ page: 1, status });
        fetchData(param)
    }

    const onHandleTableChange = (pagination: any, filters: any, sorter: any) => {
        const { current, pageSize } = pagination;
        const sort = sorter.columnKey ? sorter.order : 'desc';
        const orderBy = sorter.columnKey ? sorter.columnKey : 'updatedAt';
        const param = {
            ...params,
            limit: pageSize,
            orderBy,
            page: pageSize == params.limit ? current : 1,
            sort: sort,
        };
        fetchData(param);
    }

    return (
        <Fragment>
            <Filter
                {...props}
                dataSource={data}
                onSearch={onSearch}
                onChangeStatus={onChangeStatus}
            />
            <Table
                {...props}
                fetchDataList={fetchData}
                loading={isLoader}
                dataSource={data}
                metaData={metaData}
                deleteData={deleteData}
                onTableChange={onHandleTableChange} />
        </Fragment>
    );
}



// WEBPACK FOOTER //
// ./src/pages/role-groups/libraries/index.tsx